import { FeatureFlagKey } from 'src/DTO/Company.type';

export const featureFlagMap: Record<string, string> = {
  [FeatureFlagKey.FACEBOOK_AI]: 'Facebook AI',
  [FeatureFlagKey.AVAILABLE_WORKERS]: 'Available Workers',
};
